module.exports = __webpack_public_path__ + "img/32.b3a96a8e.png";